import Tutorial1Step1 from '@sections/creabots/components/steps/Tutorial1Step1';
import { AUTOMATION_PROJECTS_TYPE, BLOCK_CATEGORY_TYPE, BOARD_ID_TYPE, CODE_CHECK_TYPE, COMMON_CLASSES, KIT_NAME, MODAL_TYPE, Project } from '@sections/creabots/types/kits';
import * as routes from '@educabot/educablocks-cosmos';
import { getAutomationConfigForBlock, getAutomationElementForBlock } from '../config';
import TutorialSlider from '@sections/creabots/components/steps/TutorialSlider';
import { getTutorialImagesInfo } from '@sections/creabots/features/utils/getTutorialImagesInfo';

const intlPrefix = 'creabots.tutorials.automation.projects.automaticLamp';
const imgBaseUrl = '/images/creabots/automation/projects/automaticLamp';

export const automaticLamp: Project = {
  id: 1,
  name: `${intlPrefix}.name`,
  description: `${intlPrefix}.description`,
  image: `${routes.bloquesUri}${imgBaseUrl}/project_image.png`,
  boardId: BOARD_ID_TYPE.AUTOMATION,
  tutorial: [
    // Step 1.
    {
      step: {
        stepId: 0,
        modal: MODAL_TYPE.FULL,
        component: Tutorial1Step1,
        videoUrl: 'https://storage.googleapis.com/educabot-aec-cdn-1/labs/lampara-automatica.mp4',
      },
    },
    // Step 2.
    {
      step: {
        stepId: 1,
        modal: MODAL_TYPE.FULL,
        component: TutorialSlider,
        images: getTutorialImagesInfo({ kitName: KIT_NAME.AUTOMATION, projectName: AUTOMATION_PROJECTS_TYPE.AUTOMATIC_LAMP, totalSteps: 13 }),
      },
    },
    // Step 3.
    {
      step: {
        stepId: 2,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step3`,
        image: `${imgBaseUrl}/steps/step3.png`,
        ...getAutomationConfigForBlock(BLOCK_CATEGORY_TYPE.CONTROL, 1),
        completionCode: 'voidsetup\\(\\)\\{\\}voidloop\\(\\)\\{if\\(0==0\\)\\{\\}\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: getAutomationElementForBlock(BLOCK_CATEGORY_TYPE.CONTROL, 1),
        },
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 45,
            yOffset: 75,
          },
        },
      ],
    },
    // Step 4.
    {
      step: {
        stepId: 3,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step4`,
        image: `${imgBaseUrl}/steps/step4.png`,
        ...getAutomationConfigForBlock(BLOCK_CATEGORY_TYPE.ANALOG, 1),
        completionCode: 'voidsetup\\(\\)\\{\\}voidloop\\(\\)\\{if\\(analogRead\\(A0\\)==0\\)\\{\\}\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: getAutomationElementForBlock(BLOCK_CATEGORY_TYPE.ANALOG, 1),
        },
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 95,
            yOffset: 78,
          },
        },
      ],
    },
    // Step 5.
    {
      step: {
        stepId: 4,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step5`,
        image: `${imgBaseUrl}/steps/step5.png`,
        completionCode: 'voidsetup\\(\\)\\{\\}voidloop\\(\\)\\{if\\(analogRead\\(A0\\)<0\\)\\{\\}\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 345,
            yOffset: 82,
          },
        },
      ],
    },
    {
      step: {
        stepId: 4,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step5`,
        image: `${imgBaseUrl}/steps/step5.png`,
        completionCode: 'voidsetup\\(\\)\\{\\}voidloop\\(\\)\\{if\\(analogRead\\(A0\\)<[1-9]\\d*\\)\\{\\}\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 400,
            yOffset: 82,
          },
        },
      ],
    },
    // Step 6.
    {
      step: {
        stepId: 5,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step6`,
        image: `${imgBaseUrl}/steps/step6.png`,
        ...getAutomationConfigForBlock(BLOCK_CATEGORY_TYPE.OUTPUTS, 3),
        completionCode: 'voidsetup\\(\\)\\{MODULOLEDRGB_A3\\.begin\\(\\);\\}voidloop\\(\\)\\{if\\(analogRead\\(A0\\)<[1-9]\\d*\\)\\{MODULOLEDRGB_A3\\.clear\\(\\);.+MODULOLEDRGB_A3\\.show\\(\\);delayMicroseconds\\(300\\);\\}\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: getAutomationElementForBlock(BLOCK_CATEGORY_TYPE.OUTPUTS, 3),
        },
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 58,
            yOffset: 132,
          },
        },
      ],
    },
    // Step 7.
    {
      step: {
        stepId: 6,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step7`,
        image: `${imgBaseUrl}/steps/step7.png`,
        completionCode: 'voidsetup\\(\\)\\{MODULOLEDRGB_A3\\.begin\\(\\);\\}voidloop\\(\\)\\{if\\(analogRead\\(A0\\)<[1-9]\\d*\\)\\{MODULOLEDRGB_A3\\.clear\\(\\);.+MODULOLEDRGB_A3\\.show\\(\\);delayMicroseconds\\(300\\);\\}else\\{\\}\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 38,
            yOffset: 182,
          },
        },
      ],
    },
    // Step 8.
    {
      step: {
        stepId: 7,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step8`,
        image: `${imgBaseUrl}/steps/step8.png`,
        ...getAutomationConfigForBlock(BLOCK_CATEGORY_TYPE.OUTPUTS, 3),
        completionCode: 'voidsetup\\(\\)\\{MODULOLEDRGB_A3\\.begin\\(\\);\\}voidloop\\(\\)\\{if\\(analogRead\\(A0\\)<[1-9]\\d*\\)\\{MODULOLEDRGB_A3\\.clear\\(\\);.+MODULOLEDRGB_A3\\.show\\(\\);delayMicroseconds\\(300\\);\\}else\\{MODULOLEDRGB_A3\\.clear\\(\\);.+MODULOLEDRGB_A3\\.show\\(\\);delayMicroseconds\\(300\\);\\}\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: getAutomationElementForBlock(BLOCK_CATEGORY_TYPE.OUTPUTS, 3),
        },
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 55,
            yOffset: 220,
          },
        },
      ],
    },
    {
      step: {
        stepId: 7,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step8`,
        image: `${imgBaseUrl}/steps/step8.png`,
        completionCode: 'voidsetup\\(\\)\\{MODULOLEDRGB_A3\\.begin\\(\\);\\}voidloop\\(\\)\\{if\\(analogRead\\(A0\\)<[1-9]\\d*\\)\\{MODULOLEDRGB_A3\\.clear\\(\\);.+MODULOLEDRGB_A3\\.show\\(\\);delayMicroseconds\\(300\\);\\}else\\{MODULOLEDRGB_A3\\.clear\\(\\);.+MODULOLEDRGB_A3\\.Color\\(0,255,255\\)\\);\\}MODULOLEDRGB_A3\\.show\\(\\);delayMicroseconds\\(300\\);\\}\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 245,
            yOffset: 225,
          },
        },
      ],
    },
    {
      step: {
        stepId: 7,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step8`,
        image: `${imgBaseUrl}/steps/step8.png`,
        completionCode: 'voidsetup\\(\\)\\{MODULOLEDRGB_A3\\.begin\\(\\);\\}voidloop\\(\\)\\{if\\(analogRead\\(A0\\)<[1-9]\\d*\\)\\{MODULOLEDRGB_A3\\.clear\\(\\);.+MODULOLEDRGB_A3\\.show\\(\\);delayMicroseconds\\(300\\);\\}else\\{MODULOLEDRGB_A3\\.clear\\(\\);.+MODULOLEDRGB_A3\\.Color\\(0,0,255\\)\\);\\}MODULOLEDRGB_A3\\.show\\(\\);delayMicroseconds\\(300\\);\\}\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 300,
            yOffset: 225,
          },
        },
      ],
    },
    {
      step: {
        stepId: 7,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step8`,
        image: `${imgBaseUrl}/steps/step8.png`,
        completionCode: 'voidsetup\\(\\)\\{MODULOLEDRGB_A3\\.begin\\(\\);\\}voidloop\\(\\)\\{if\\(analogRead\\(A0\\)<[1-9]\\d*\\)\\{MODULOLEDRGB_A3\\.clear\\(\\);.+MODULOLEDRGB_A3\\.show\\(\\);delayMicroseconds\\(300\\);\\}else\\{MODULOLEDRGB_A3\\.clear\\(\\);.+MODULOLEDRGB_A3\\.Color\\(0,0,0\\)\\);\\}MODULOLEDRGB_A3\\.show\\(\\);delayMicroseconds\\(300\\);\\}\\}',
        completionCodeCheck: CODE_CHECK_TYPE.REGEX,
      },
      hints: [
        {
          element: {
            class: COMMON_CLASSES.INITIAL_BLOCK_CLASS,
            xOffset: 350,
            yOffset: 225,
          },
        },
      ],
    },
    // Step 9.
    {
      step: {
        stepId: 8,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step9`,
        image: `${imgBaseUrl}/steps/step9.gif`,
        completionCodeCheck: CODE_CHECK_TYPE.BUILT,
      },
      hints: [
        {
          element: {
            image: `${routes.bloquesUri}/images/creabots/hint_big.png`,
            class: COMMON_CLASSES.BUILD_BLOCKLY_BTN_CLASS,
            xOffset: -26,
            yOffset: -35,
          },
        },
      ],
    },
    // Step 10.
    {
      step: {
        stepId: 9,
        modal: MODAL_TYPE.DOCKED,
        description: `${intlPrefix}.step10`,
        image: `${imgBaseUrl}/steps/step10.gif`,
      },
    },
  ],
};
